import ReactGA from 'react-ga4';
import {GA_ID} from "../../globalConfig";

// Инициализация Google Analytics
export const initializeAnalytics = () => {
    ReactGA.initialize(GA_ID); // Замените на ваш ID GA4
};

// Отслеживание страницы
export const trackPageView = (path: string) => {
    ReactGA.send({ hitType: 'pageview', page: path });
};

// Отслеживание событий
export const trackEvent = (category: string, action: string, label?: string) => {
    ReactGA.event({
        category,
        action,
        label,
    });
};